var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNumberGreenThree = function SvgNumberGreenThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 7,
    y: 7,
    fill: "#51C394",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    x: 3.8,
    y: 3.8,
    stroke: "#51C394",
    strokeOpacity: 0.5,
    strokeWidth: 6.4,
    rx: 19.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.618 23.453v-1.325q.595 0 1.056-.154.48-.153.806-.422.326-.288.5-.634a1.6 1.6 0 0 0 .191-.748q0-.48-.192-.845a1.3 1.3 0 0 0-.556-.557q-.365-.192-.941-.192-.807 0-1.363.5-.538.48-.538 1.228h-2.554q0-1.152.557-2.035a4.03 4.03 0 0 1 1.575-1.421q.998-.518 2.323-.518 1.402 0 2.38.499 1 .499 1.517 1.325.519.825.519 1.843 0 1.095-.692 1.881-.69.768-1.881 1.172-1.19.402-2.707.403m.749 6.816q-1.152 0-2.055-.346a4.6 4.6 0 0 1-1.536-.94 4.5 4.5 0 0 1-.98-1.383 4.1 4.1 0 0 1-.345-1.651h2.727q0 .652.307 1.113t.826.71q.518.231 1.132.231.634 0 1.095-.211.48-.23.749-.653.268-.421.268-1.056 0-.46-.192-.845a1.7 1.7 0 0 0-.576-.672 2.55 2.55 0 0 0-.921-.403 4.6 4.6 0 0 0-1.248-.153v-1.46q1.229 0 2.246.212 1.037.21 1.805.69.768.462 1.19 1.191.423.711.423 1.728 0 1.152-.615 2.035-.595.884-1.709 1.383-1.094.48-2.591.48"
  })));
};
export default SvgNumberGreenThree;